import React from 'react';

import UbicacionCompoent from "../components/UbicacionComponent"
import ModalRecorridoComponent from "../components/ModalRecorridoComponent";
import FranjaCotizar from "../components/FranjaCotizar";


import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";



const Recorre = () => {

    const heroSlide = {
        arrows: false,
        dots: false,
        infinite: true,
        autoplay: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
    };

    return (
        <div className="page recorre">

            {/* version telefono */}
            <section id="hero">
                <div className="arriba">
                    <div className="imagen">
                    </div>
                    <div className="contenido">
                        <div className="logo">
                            <img
                                src={"/images/recorre/logo_2_celular.png"}
                                alt="Logo Edificio Almirante"
                            />
                        </div>
                        <p className="texto">TE INVITAMOS <span>A TU NUEVO</span> <span>DEPARTAMENTO</span></p>
                    </div>
                </div>
            </section>

            <section id="recorridos">
                <div className="arriba">
                    <p className="titulo">RECORRE</p>
                    <p className="texto">ENTRA A TU NUEVO <span>DEPARTAMENTO</span></p>
                </div>

                <div className="contenido">
                    <div>
                        <ModalRecorridoComponent
                            textButton="Modelo B"
                            tituloModal="MODELO B"
                            link="https://almirante.cl/tours/Modelo%20B/index.htm"
                        />
                    </div>
                    <div>
                        <ModalRecorridoComponent
                            textButton="Modelo C"
                            tituloModal="Modelo C"
                            link="https://almirante.cl/tours/Modelo%20C/index.htm"
                        />
                    </div>
                    <div>
                        <ModalRecorridoComponent
                            textButton="Modelo D"
                            tituloModal="MODELO D"
                            link="https://almirante.cl/tours/Modelo%20D/index.htm"
                        />
                    </div>
                    <div>
                        <ModalRecorridoComponent
                            textButton="Plantas Edificio"
                            tituloModal="PLANTAS EDIFICIO"
                            link="https://almirante.cl/tours/plantas/index.htm"
                        />
                    </div>
                    <div>
                        <ModalRecorridoComponent
                            textButton="Modelo A1"
                            tituloModal="MODELO A1"
                            link="https://www.almirante.cl/tours/Modelo%20A1/"
                        />
                    </div>
                    <div>
                        <ModalRecorridoComponent
                            textButton="Cowork"
                            tituloModal="COWORK"
                            link="https://almirante.cl/tours/cowork%20hall/index.htm"
                        />
                    </div>
                </div>

                <div className="icono-recorrido">
                    <img
                        src="/images/recorre/icono_6_celular.png"
                        alt="icono recorrido virtual"
                    />
                </div>

                <div className="arriba">
                    <p className="titulo">RECORRE</p>
                    <p className="texto">Vive una experiencia única <span>con Recorrido Virtual 360°</span></p>
                </div>
                <div className='contenido'>
                    <ModalRecorridoComponent
                        textButton="Recorrido"
                        tituloModal="Recorrido"
                        link="https://almirante.cl/tours/cowork%20hall/index.htm"
                    />
                </div>
            </section>

            {/* version tablet y escritorio */}
            <section id="hero-slide">
                <div className='slide-hero'>
                    <Slider {...heroSlide}>
                        <div className='item'>
                            <div className='contenido'>
                                <p className='texto'>TE INVITAMOS <span>A ENTRAR</span></p>
                                <p className='texto-1'>A TU NUEVA <span> INVERSIÓN</span> <span>TU NUEVO</span> DEPARTAMENTO</p>
                                <div className="imagen">
                                    <img
                                        src={"/images/recorre/icono_360_tablet_blanco.png"}
                                        alt="icono recorrido 360"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='item'>
                            <div className='contenido'>
                                <p className='texto'>TE INVITAMOS <span>A ENTRAR</span></p>
                                <p className='texto-1'>A TU NUEVA <span> INVERSIÓN</span> <span>TU NUEVO</span> DEPARTAMENTO</p>
                                <div className="imagen">
                                    <img
                                        src={"/images/recorre/icono_360_tablet_blanco.png"}
                                        alt="icono recorrido 360"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='item'>
                            <div className='contenido'>
                                <p className='texto'>TE INVITAMOS <span>A ENTRAR</span></p>
                                <p className='texto-1'>A TU NUEVA <span> INVERSIÓN</span> <span>TU NUEVO</span> DEPARTAMENTO</p>
                                <div className="imagen">
                                    <img
                                        src={"/images/recorre/icono_360_tablet_blanco.png"}
                                        alt="icono recorrido 360"
                                    />
                                </div>
                            </div>
                        </div>
                    </Slider>

                    <div className='texto-abajo'>
                        <p className='big'>CONOCE</p>
                        <p className='small'>NUESTRO PILOTO</p>
                    </div>
                </div>
                <div className='fondo'></div>
            </section>

            <section id="recorridos-360">
                <div className='arriba'>
                    <div className="entrada">
                        <p>Vive una experiencia única<span> con Recorrido Virtual 360°</span></p>
                    </div>
                    <div className="recorridos arriba">
                        <div className="contenido">
                            <div>
                                <ModalRecorridoComponent
                                    textButton="Ver Recorrido"
                                    tituloModal="Ver Recorrido"
                                    link="https://my.matterport.com/show/?m=AG3gVinVpZQ"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='abajo'>
                    <div className="entrada">
                        <p>Recorre cada rincón,<span> revisa cada detalle</span></p>
                        <img
                            src={"/images/recorre/icono_360_tablet.png"}
                            alt="icono 360"
                        />
                    </div>
                    <div className="recorridos">
                        <div className="contenido">
                            <div>
                                <ModalRecorridoComponent
                                    textButton="Modelo B"
                                    tituloModal="MODELO B"
                                    link="https://almirante.cl/tours/Modelo%20B/index.htm"
                                />
                            </div>
                            <div>
                                <ModalRecorridoComponent
                                    textButton="Modelo C"
                                    tituloModal="Modelo C"
                                    link="https://almirante.cl/tours/Modelo%20C/index.htm"
                                />
                            </div>
                            <div>
                                <ModalRecorridoComponent
                                    textButton="Modelo D"
                                    tituloModal="MODELO D"
                                    link="https://almirante.cl/tours/Modelo%20D/index.htm"
                                />
                            </div>
                            <div>
                                <ModalRecorridoComponent
                                    textButton="Plantas Edificio"
                                    tituloModal="PLANTAS EDIFICIO"
                                    link="https://almirante.cl/tours/plantas/index.htm"
                                />
                            </div>
                            <div>
                                <ModalRecorridoComponent
                                    textButton="Modelo A1"
                                    tituloModal="MODELO A1"
                                    link="https://almirante.cl/tours/Modelo%20A1/index.htm"
                                />
                            </div>
                            <div>
                                <ModalRecorridoComponent
                                    textButton="Cowork"
                                    tituloModal="COWORK"
                                    link="https://almirante.cl/tours/cowork%20hall/index.htm"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <FranjaCotizar />
            <UbicacionCompoent />
        </div>
    )
}

export default Recorre